<script>
    import _ from 'lodash';
    import {network, store} from '../../stores.js';
    import ButtonConfirm from '../form/Button.svelte';
    import {createEventDispatcher, onMount} from 'svelte';

    const dispatch = createEventDispatcher();

    const axis = store('axis', '', false);
    const user = store('credential', 'getAuth');
    const cart = store('cart-items', '', '[]');

    export let args;

    // Независимые состояния для скрытия/показа цен
    let showDealerPrice = false;
    let showPurchasePrice = false;

    // При монтировании компонента читаем сохраненные настройки
    onMount(() => {
        if (typeof localStorage !== 'undefined') {
            showDealerPrice = localStorage.getItem('showDealerPrice') === 'true';
            showPurchasePrice = localStorage.getItem('showPurchasePrice') === 'true';
        }
    });

    // Функции переключения теперь также сохраняют выбор в localStorage
    const toggleDealerPrice = () => {
        showDealerPrice = !showDealerPrice;
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('showDealerPrice', showDealerPrice);
        }
    };

    const togglePurchasePrice = () => {
        showPurchasePrice = !showPurchasePrice;
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem('showPurchasePrice', showPurchasePrice);
        }
    };

    const add_item = async () => {
        let id = args.id ? args.id : null;
        let item = Object.assign({}, args.item);

        let popup;
        let data = ($cart || []);
        let index = id ? data.findIndex((el) => el.idTovar === id) : null;

        switch (true) {
            // изменение количества
            case !$axis && id !== null && data[index] && item.quantity !== data[index].quantity: {
                item.idTovar = id; // kostil
                data[index] = item;

                popup = new bootstrap.Modal(document.getElementById('item-update'));
                break;
            }

            // изменение товара
            case id !== null: {
                // здесь товар который редактировался - удаляется из корзины
                data = data.filter((el) => el.idTovar !== id);

                // вызываем коррекцию товара, с тем же idTovar
                item.idTovar = await network.update(_.merge({}, item, {idTovar: id}));

                data.push(item);

                popup = new bootstrap.Modal(document.getElementById('item-upgrade'));
                break;
            }

            // создание товара
            default: {
                if (!item.idTovar) {
                    item.idTovar = await network.create(item, args.calc);
                }

                data.push({...item, calc: args.calc});

                popup = new bootstrap.Modal(document.getElementById('item-add'));
                break;
            }
        }

        if (!$axis) {
            popup.show();
        }

        // выход из редактирования
        id = null;
        dispatch('reset');
        document.body.dispatchEvent(new CustomEvent('reset', {}));

        if ($axis) {
            let params = {
                calc: args.calc,
                idTovar: item.idTovar,
                name: item.title,
                artikul: item.comment,
                ind1: item.params.ind1,
                ind2: item.params.ind2,
                ind3: item.params.ind3,
                kolvo: item.quantity,
                maxkolvo: item.quantity,

                summa: item.price.rozn,
                summaRozn: item.price.rozn,
                summaDil: item.price.opt,
                sebestoim: item.price.sebest,

                maxDay: item.maxDay,
                vStrukture: 11,
            };

            window.top.postMessage('add_item::' + JSON.stringify(params), '*');
        } else {
            cart.save(data);

            setTimeout(() => {
                popup.hide();
                document.querySelector('[data-bs-target="#cartPanel"]').click();
            }, 1500);
        }
    };
</script>

{#if (args.item && args.item.quantity || args.id) && (Object.keys(args.item.materials).length || args.item.idTovar) }
    <div class="card-body">
        <div class="row text-center d-flex justify-content-center">
            {#if $user && ($user.tip.toLowerCase().includes('администратор') || $user.tip.toLowerCase().includes('замер') || $user.tip.toLowerCase().includes('главный'))}
                <div class="col-4 pb-2">
                    <span class="d-inline d-md-none"><b>РРЦ.</b>:<br></span>
                    <span class="d-none d-md-inline"><b>Розница</b>:<br></span>
                    {#if args.item.quantity > 1}
                        {(args.item.price.rozn).toLocaleString()}
                        &times;
                        {args.item.quantity}шт
                        =
                    {/if}
                    {(args.item.price.rozn * args.item.quantity).toLocaleString()}
                </div>
            {/if}
            {#if $user && ($user.tip.toLowerCase().includes('администратор') || $user.tip.toLowerCase().includes('менеджер'))}
                <div class="col-4 pb-2">
                    <span class="d-inline d-md-none"><b>Дилер.</b>:<br></span>
                    <span class="d-none d-md-inline"><b>Дилерская</b>:<br></span>
                    <div class="user-select-none" style="cursor: pointer;" on:click={toggleDealerPrice}
                         on:keydown={(e) => e.key === 'Enter' && toggleDealerPrice()} tabindex="0" role="button"
                         title="Нажмите, чтобы показать/скрыть дилерскую цену">
                        {#if showDealerPrice}

                            {#if args.item.quantity > 1}
                                {(args.item.price.opt).toLocaleString()}
                                &times;
                                {args.item.quantity}шт
                                =
                            {/if}
                            {(+args.item.price.opt * args.item.quantity).toLocaleString()}
                        {:else}
                            <span class="text-muted" style="letter-spacing: 2px;">••••••</span>
                        {/if}
                    </div>
                </div>

                {#if $user && $user.tip.toLowerCase().includes('администратор')}
                    <div class="col-4 pb-2">
                        <span class="d-inline d-md-none"><b>Закуп.</b>:<br></span>
                        <span class="d-none d-md-inline"><b>Закупочная</b>:<br></span>
                        <div class="user-select-none" style="cursor: pointer;" on:click={togglePurchasePrice}
                             on:keydown={(e) => e.key === 'Enter' && togglePurchasePrice()} tabindex="0" role="button"
                             title="Нажмите, чтобы показать/скрыть закупочную цену">
                            {#if showPurchasePrice}
                                {#if args.item.quantity > 1}
                                    {(args.item.price.sebest).toLocaleString()}
                                    &times;
                                    {args.item.quantity}шт
                                    =
                                {/if}
                                {(+args.item.price.sebest * args.item.quantity).toLocaleString()}
                            {:else}
                                <span class="text-muted" style="letter-spacing: 2px;">••••••</span>
                            {/if}
                        </div>
                    </div>
                {/if}
            {/if}
        </div>

        <ButtonConfirm add_item={add_item} id={args.id} errors={args.errors}/>
    </div>
{/if}
